module.exports = __webpack_public_path__ + "img/lemon-left-7.5591bafc.png";